<template>
  <v-hover>
    <v-card
      slot-scope="{ hover }"
      raised
      class="mb-1"
      :class="{ 'red lighten-4': errorUpload }"
    >
      <!--<editor-fold desc="Uploading loader">-->
      <v-progress-circular
        v-if="uploading"
        :indeterminate="true"
        :size="50"
        :width="3"
        height="90px"
        :value="file.progress"
      />
      <!--</editor-fold>-->

      <!--<editor-fold desc="Blob thumbnail">-->
      <v-img
        v-else-if="file.blob ? file.blob : file.thumb"
        :src="file.blob ? file.blob : file.thumb"
        max-height="90px"
      >
        <v-expand-transition>
          <v-row
            v-if="hover"
            class="transition-fast-in-fast-out v-card--reveal"
            style="height: 100%;"
          >
            <v-spacer />
            <v-col class="shrink">
              <div class="d-flex flex-column">
                <v-btn
                  v-if="canRemove"
                  text
                  small
                  class="ma-0"
                  @click.native.stop="removeFile(file.id)"
                >
                  <v-icon :color="errorUpload ? 'orange lighten-4' : 'red'">
                    clear
                  </v-icon>
                </v-btn>
                <v-btn
                  v-if="uploaded"
                  text
                  small
                  class="ma-0"
                  @click.native.stop="previewImage(file.response.path)"
                >
                  <v-icon color="grey">
                    open_with
                  </v-icon>
                </v-btn>
                <v-btn
                  v-if="!uploading && errorUpload"
                  text
                  small
                  class="ma-0"
                  @click.native.stop="retryUpload"
                >
                  <v-icon color="orange lighten-4">
                    autorenew
                  </v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-expand-transition>
      </v-img>
    <!--</editor-fold>-->
    </v-card>
  </v-hover>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'FileCard',
    props: {
      file: {
        type: Object,
        default: () => ({})
      },
      canRemove: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      uploading() {
        return this.file.active && parseInt(this.file.progress) < 100
      },
      uploaded() {
        return this.file.success && parseInt(this.file.progress) === 100 && this.file.response.id
      },
      errorUpload() {
        return !this.file.success && !this.file.active
      },
      error() {
        return this.file.error
      }
    },
    methods: {
      ...mapActions(['previewImage', 'removeFile']),
      retryUpload() {
        // todo: retry upload this file
        // this.$parent.$refs.upload.active = true
      }
    }
  }
</script>
<style>
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%;
  }
</style>
